module.exports = __webpack_public_path__ + "static/img/1022.241d2dd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1022.jpg
// module id = 204
// module chunks = 0